import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useAllOrganizations } from '../../../../../../hooks/useAllOrganizations';

export const useCompanyFilter = ({ setFilters, value }) => {
  const { allOrganizationsList } = useAllOrganizations();

  const formSchema = Yup.object().shape({
    company: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const options = useMemo(() => {
    const organizationOptions = (allOrganizationsList || []).map(({ id, name }) => ({
      value: id.toString(),
      label: name,
    }));
    return [{ label: 'Any', value: 'any' }, ...organizationOptions];
  }, [allOrganizationsList]);

  // Get initial company option from allOrganizationsList
  const selected = useMemo(() => {
    if (!value) {
      return { label: 'Any', value: 'any' };
    }

    const company = (allOrganizationsList || []).find((org) => org.id.toString() === value.toString());
    if (company) {
      return {
        value: company.id.toString(),
        label: company.name,
      };
    }

    return { label: 'Any', value: 'any' };
  }, [value, allOrganizationsList]);

  const onSubmit = ({ company }) => {
    const companyValue = company.value || 'any';
    setFilters(
      { companyId: companyValue === 'any' ? null : companyValue },
      {
        removeFilters: companyValue === 'any' ? ['companyId'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
    selected,
    options,
  };
};

useCompanyFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
